import { FlexRow } from '@editor/components/utilities/layouts';
import { h2, h3, p2, p3 } from '@repo/ui/components/Typography';
import { hideScrollBar } from '@repo/ui/components/utilities';
import { VerticallyScrollable } from '@repo/ui/deprecated/VerticallyScrollable';
import { QUERIES } from '@repo/ui/queries';
import styled from 'styled-components';

export const ModalContentContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`;

export const OffboardingContentWrapper = styled(VerticallyScrollable)<{
  narrow?: boolean;
}>`
  display: flex;
  flex-direction: column;
  max-width: 100%;
  box-sizing: border-box;
  text-align: center;
  align-items: center;
  padding: 48px 12px 32px;
  max-height: 98vh;
  ${hideScrollBar};

  ${QUERIES.largeTabletAndUp} {
    padding: ${({ narrow }) => (narrow ? '48px' : '48px 70px')};
  }
`;

export const ResponsiveHeader = styled.h2`
  ${h3};

  ${QUERIES.largeTabletAndUp} {
    ${h2};
  }
`;

export const ResponsiveText = styled.p`
  ${p3};

  ${QUERIES.largeTabletAndUp} {
    ${p2};
  }
`;

export const ResponsiveButtonsWrapper = styled(FlexRow)`
  gap: 12px;
  width: 100%;
  flex-wrap: wrap;

  ${QUERIES.largeTabletAndUp} {
    flex-wrap: nowrap;
  }
`;
